module.exports = __webpack_public_path__ + "img/V19.bc099f7a.png";